/**
 * SubNav component is use to show the navigation bar with menus
 * selectedTab property is required to select the active menu
 * action property is required to handle menu click which need to be handled in the parent component
 * tabs property will have menu labels and active status.
 */

import React, { useState, useEffect } from "react";
import fordStyles from "./SubNav.module.scss";
import lincolnStyles from "./SubNav-Lincoln.module.scss";
import commonFordStyles from "./../../styles/common/CommonStyles.module.scss";
import commonLincolnStyles from "./../../styles/common/CommonStyles-Lincoln.module.scss";
import SubNavDropdown from "./SubNavDropdown";
import HasPermissionTo from "../../common/HasPermissionTo";
import SubNavTabs from "./SubNavTabs";
import { withTranslation } from "react-i18next";
import CustomDropdown from "./CustomDropdown";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";
import UpperCaseText from "../../utils/UpperCaseText";

const SubNav = (props) => {
  const [visibleTabsCount, setVisibleTabsCount] = useState(100);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const tabletWindowWidth = 1024;
  const onboardedDealers =
    UpperCaseText(props.user?.userType) === "DEALER" &&
    typeof props.user?.getOnboardedDealerGroup === "function"
      ? props.user.getOnboardedDealerGroup()
      : [];

  useEffect(() => {
    if (props.tabs) {
      window.addEventListener("resize", handleWindowResize);
      getVisibleTabsCount();
    }

    return () => {
      if (props.tabs) {
        window.removeEventListener("resize", handleWindowResize);
      }
    };
  }, []);

  const handleWindowResize = () => {
    setWindowWidth(window.innerWidth);
    setVisibleTabsCount(100);
    getVisibleTabsCount();
  };

  const inViewPort = (boundary, divPaddingRight, windowWidth) => {
    return boundary.left >= 0 && boundary.right + divPaddingRight < windowWidth;
  };

  const getVisibleTabsCount = () => {
    if (windowWidth > tabletWindowWidth) {
      let visibleTabs = 0;
      let notVisibleTabsFlag = false;
      let elemRightBoundary = 0;
      const currentWindowWidth = windowWidth;
      const divPaddingRightPercent = 6;
      const divPaddingRight =
        currentWindowWidth * (divPaddingRightPercent / 100);
      const moreTabWidth = 172;
      props.tabs.forEach((item) => {
        if (!notVisibleTabsFlag) {
          const elem = document.getElementById("tab" + item.id);
          const boundary = elem.getBoundingClientRect();
          if (inViewPort(boundary, divPaddingRight, currentWindowWidth)) {
            visibleTabs = visibleTabs + 1;
          } else {
            if (
              elemRightBoundary + divPaddingRight + moreTabWidth >=
              currentWindowWidth
            ) {
              visibleTabs = visibleTabs - 1;
            }
            notVisibleTabsFlag = true;
          }
          elemRightBoundary = boundary.right;
        }
      });

      setVisibleTabsCount(visibleTabs);
    }
  };

  const isFordBrand = IS_FORD_BRAND(props.user.brand);
  const styles = isFordBrand ? fordStyles : lincolnStyles;
  const commonStyles = isFordBrand ? commonFordStyles : commonLincolnStyles;

  return (
    <div
      className={`${styles.subNav} ${
        props.displayDetails ? styles.rootNavBottom : null
      }`}
    >
      <div>
        <div className={styles.container}>
          {props.dashboard && props.user.fullName ? (
            <p id="welcome" className={styles.welcome}>
              {props.t("SubNav.welcome")} {props.user.fullName.split(" ")[0]}
            </p>
          ) : (
            ""
          )}
          <div className={styles.titleDiv}>
            <div className={commonStyles.pageTitle}>{props.title}</div>
            {!props.restrictDropdown ? (
              props.showCustomDropdown ? (
                <CustomDropdown {...props} isFordBrand={isFordBrand} />
              ) : (
                <HasPermissionTo
                  perform={["AllCMA:view"]}
                  permissions={props.user.permissions.rolePermissions}
                  condition={onboardedDealers.length > 1}
                  render={() => <SubNavDropdown {...props} />}
                />
              )
            ) : null}
          </div>
        </div>
        {props.renderSubHeader && props.subHeader()}

        <SubNavTabs
          visibleTabsCount={visibleTabsCount}
          isFordBrand={isFordBrand}
          {...props}
        />
      </div>
    </div>
  );
};

export default withTranslation("emp")(SubNav);
